import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "text-gray-333" }
const _hoisted_2 = { class: "font-size-24" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-6" }, null, -1)
const _hoisted_4 = { class: "w-full mb-8" }
const _hoisted_5 = { class: "w-2/5 mb-6" }
const _hoisted_6 = { class: "w-2/5 mb-6" }
const _hoisted_7 = { class: "w-full mb-8" }
const _hoisted_8 = {
  key: 0,
  class: "w-2/5 mb-6"
}
const _hoisted_9 = {
  key: 1,
  class: "w-full mb-8"
}
const _hoisted_10 = { class: "w-2/5 mb-6" }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "extra-overtime" }
const _hoisted_13 = { class: "mr-2 text-base mt-3" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "ml-2 mr-4 text-base" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Label = _resolveComponent("Label")
  const _component_RadioGroup = _resolveComponent("RadioGroup")
  const _component_Select = _resolveComponent("Select")
  const _component_Input = _resolveComponent("Input")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('automatictBreak.overtimeSetting')), 1),
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_Label, {
        textLabel: _ctx.t('distinguishingBetweenOvertimeAndNonStatutoryWorking')
      }, null, 8, ["textLabel"]),
      _createVNode(_component_RadioGroup, {
        optionsRadio: _ctx.distinguishingBetweenOvertimeNonStatutoryList,
        modelValue: 
          _ctx.workingStyleMasterParams.is_distinguishing_overtime_and_non_statutory
        ,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (
          _ctx.workingStyleMasterParams.is_distinguishing_overtime_and_non_statutory
         = $event))
      }, null, 8, ["optionsRadio", "modelValue"])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_Label, {
        textLabel: _ctx.t('settingRegularWorkingHoursPerDay')
      }, null, 8, ["textLabel"]),
      _createVNode(_component_Select, {
        placeholder: _ctx.t('placeholderSelect'),
        optionsSelect: _ctx.settingRegularWorkingHourPerDayList,
        "item-text": "text",
        modelValue: _ctx.workingStyleMasterParams.setting_work_time_type,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.workingStyleMasterParams.setting_work_time_type = $event))
      }, null, 8, ["placeholder", "optionsSelect", "modelValue"])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_Label, {
        textLabel: _ctx.t('automatictBreak.treatmentOfOvertime')
      }, null, 8, ["textLabel"]),
      _createVNode(_component_Select, {
        placeholder: _ctx.t('placeholderSelect'),
        optionsSelect: _ctx.optionsTreatmentOfOvertime,
        "item-text": "text",
        modelValue: _ctx.workingStyleMasterParams.way_calc_overtime,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.workingStyleMasterParams.way_calc_overtime = $event))
      }, null, 8, ["placeholder", "optionsSelect", "modelValue"])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode(_component_Label, {
        textLabel: _ctx.t('automatictBreak.weeklyCalculationOutside')
      }, null, 8, ["textLabel"]),
      _createVNode(_component_RadioGroup, {
        optionsRadio: _ctx.optionsWeeklyOutside,
        modelValue: 
          _ctx.workingStyleMasterParams.is_calc_non_statutory_overtime_by_week
        ,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (
          _ctx.workingStyleMasterParams.is_calc_non_statutory_overtime_by_week
         = $event))
      }, null, 8, ["optionsRadio", "modelValue"])
    ]),
    (
        _ctx.workingStyleMasterParams.is_calc_non_statutory_overtime_by_week ===
        _ctx.CALC_NON_STATUTORY_OVERTIME_BY_WEEK_TYPE.DO
      )
      ? (_openBlock(), _createBlock("div", _hoisted_8, [
          _createVNode(_component_Label, {
            textLabel: _ctx.t('automatictBreak.calculateWeekCrossedDealine')
          }, null, 8, ["textLabel"]),
          _createVNode(_component_Select, {
            placeholder: _ctx.t('placeholderSelect'),
            optionsSelect: _ctx.optionsWeekCrossedDeadline,
            "item-text": "text",
            modelValue: 
          _ctx.workingStyleMasterParams.way_calc_weekly_over_monthly_closing_day
        ,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (
          _ctx.workingStyleMasterParams.way_calc_weekly_over_monthly_closing_day
         = $event))
          }, null, 8, ["placeholder", "optionsSelect", "modelValue"])
        ]))
      : _createCommentVNode("", true),
    (
        _ctx.workingStyleMasterParams.is_calc_non_statutory_overtime_by_week ===
        _ctx.CALC_NON_STATUTORY_OVERTIME_BY_WEEK_TYPE.DO
      )
      ? (_openBlock(), _createBlock("div", _hoisted_9, [
          _createVNode(_component_Label, {
            textLabel: _ctx.t('roundingCalculatingWeeksAcrossDeadlines')
          }, null, 8, ["textLabel"]),
          _createVNode(_component_RadioGroup, {
            optionsRadio: _ctx.roundingWeeklyOvertimeList,
            modelValue: _ctx.workingStyleMasterParams.way_rounding_overtime_by_week,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.workingStyleMasterParams.way_rounding_overtime_by_week = $event))
          }, null, 8, ["optionsRadio", "modelValue"])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_10, [
      _createVNode(_component_Label, {
        textLabel: _ctx.t('automatictBreak.extraOvertimeFunction')
      }, null, 8, ["textLabel"]),
      _createVNode(_component_Select, {
        placeholder: _ctx.t('placeholderSelect'),
        optionsSelect: _ctx.extraOvertimeFunctionList,
        "item-text": "text",
        modelValue: _ctx.workingStyleMasterParams.is_using_special_overtime,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.workingStyleMasterParams.is_using_special_overtime = $event))
      }, null, 8, ["placeholder", "optionsSelect", "modelValue"])
    ]),
    (
        _ctx.workingStyleMasterParams.is_using_special_overtime ===
          _ctx.USING_SPECIAL_OVERTIME_TYPE.USE ||
        _ctx.workingStyleMasterParams.is_calc_non_statutory_overtime_by_week !==
          _ctx.CALC_NON_STATUTORY_OVERTIME_BY_WEEK_TYPE.DO
      )
      ? (_openBlock(), _createBlock("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode(_component_Label, {
              textLabel: _ctx.t('automatictBreak.afterExtraHours')
            }, null, 8, ["textLabel"]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.workingStyleMasterParams.working_style_special_overtimes, (item, index) => {
              return (_openBlock(), _createBlock("div", {
                class: "flex mb-5",
                key: index
              }, [
                _createVNode("div", _hoisted_13, _toDisplayString(_ctx.t('automatictBreak.overtimeWorkOfMonth')), 1),
                _createVNode("div", _hoisted_14, [
                  _createVNode(_component_Input, {
                    width: "80px",
                    modelValue: 
                _ctx.workingStyleMasterParams.working_style_special_overtimes[index]
                  .special_overtime
              ,
                    "onUpdate:modelValue": ($event: any) => (
                _ctx.workingStyleMasterParams.working_style_special_overtimes[index]
                  .special_overtime
               = $event),
                    validated: _ctx.validated,
                    "error-server": 
                _ctx.errorServerData[
                  `working_style_special_overtimes.${index}.special_overtime`
                ]
              
                  }, {
                    default: _withCtx(() => [
                      _createVNode("span", _hoisted_15, _toDisplayString(_ctx.t('automatictBreak.recordTimeExceeded')), 1)
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "validated", "error-server"])
                ]),
                (
              _ctx.workingStyleMasterParams.working_style_special_overtimes.length >
              1
            )
                  ? (_openBlock(), _createBlock("span", {
                      key: 0,
                      class: "cp-icon-minus-circle text-2xl cursor-pointer text-red-ff hover:opacity-75 mr-2 mt-3 h-fit-content",
                      onClick: ($event: any) => (_ctx.removeSpecialOverTime(item, index))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isAddSpecialOverTime(index))
                  ? (_openBlock(), _createBlock("span", {
                      key: 1,
                      class: "flex cursor-pointer text-light-blue hover:opacity-75 mt-3 cp-icon-plus-circle text-2xl h-fit-content",
                      onClick: ($event: any) => (_ctx.addSpecialOverTime(index))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}